<template>
    <div class="dots">
        <div v-for="n in size" :key="n" class="dot" :style="getStyle(n)"/>
    </div>
</template>
<script>
export default {
    name: 'Dots',
    props: {
        color: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            required: true,
        },
        value: {
            type: Number,
            required: true,
        },
    },
    methods: {
        getStyle (n) {
            const style = {
                border: `1px solid ${this.color}`,
            };

            if (n <= this.value) {
                style.backgroundColor = this.color;
            }

            return style;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

.dots {
    display: flex;
    align-items: center;

    > .dot {
        @include square(10px);
        border-radius: 50%;

        &:not(:last-child):not(:only-child) {
            margin-right: 10px;
        }
    }
}
</style>
